<template>
    <div class="purchase-container" >
  <!-- <el-dialog v-model="dialogVisible" :title="title" width="60%"> -->
    <el-tabs v-model="activeTab">
      <el-tab-pane label="充值记录" name="purchase">
        <el-table :data="purchaseRecords.slice((currentPage-1)*pageSize, currentPage*pageSize)" stripe>
          <el-table-column prop="source" label="任务名称" width="150">
            
          </el-table-column>
          <el-table-column prop="transAmount" label="充值金额" width="100"></el-table-column>
          <el-table-column prop="afterBalance" label="面试币" width="100"></el-table-column>
          <el-table-column prop="createTime" label="时间" width="180"></el-table-column>
        </el-table>
        <el-pagination
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-size="pageSize"
          layout="total, prev, pager, next"
          :total="purchaseRecords.length">
        </el-pagination>
      </el-tab-pane>
      <el-tab-pane label="消费记录" name="consumption">
        <el-table :data="consumptionRecords.slice((currentPage-1)*pageSize, currentPage*pageSize)" stripe>
          <!-- <el-table-column prop="source" label="任务类型" width="100">  </el-table-column> -->
          <el-table-column prop="remark" label="任务名称" width="100">  </el-table-column>
          <el-table-column prop="transAmount" label="面试币" width="100"></el-table-column>
          <el-table-column prop="createTime" label="时间"></el-table-column>
        </el-table>
        <el-pagination
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-size="pageSize"
          layout="total, prev, pager, next"
          :total="consumptionRecords.length">
        </el-pagination>
      </el-tab-pane>
    </el-tabs>

  <!-- </el-dialog> -->
  </div>
</template>

<script>
import { rechargeList } from "@/api/interview";
import { useStore } from "@/store";
export default {
  props: {
    modelValue: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: '购买记录'
    }
  },
  data() {
    return {
      dialogVisible: this.modelValue,
      activeTab: 'purchase',
      store:{},
      purchaseRecords: [
       
      ],
      consumptionRecords: [
      ],
      currentPage: 1,
      pageSize: 10
    };
  },
  watch: {
    modelValue(newVal) {
      this.dialogVisible = newVal;
    },
    dialogVisible(newVal) {
      this.$emit('update:modelValue', newVal);
    }
  },
  created() {
    this.store = useStore();
    this.purchaseRecordsHandler();
    this.consumptionRecordsHandler();
  },
  methods: {
    // 购买记录
    async purchaseRecordsHandler() {
       // 参数准备
      const obj = {
         userId: 0,
          accountType: 100,
          subTypes: [
            10,20
          ], 
          prodTypes: [
            "RECHARGE"
          ]
        };
      const response = await rechargeList(obj)
      if (response.code === 200) {
         this.purchaseRecords = response.data.accountLogList; 
         this.totalRecords = response.data.accountLogList.length;
        }
    },
    // 消耗记录
    async consumptionRecordsHandler() {
       // 参数准备
      const obj = {
         userId: 0,
          accountType: 100,
          subTypes: [
            10,20
          ], 
          prodTypes: [
            "PAY"
          ]
        };
      const response = await rechargeList(obj)
      if (response.code === 200) {
         this.consumptionRecords = response.data.accountLogList; 
        console.log(this.consumptionRecords)
         this.totalRecords = response.data.accountLogList.length;

        }
    },
    toggleExpand(index) {
      this.purchaseRecords[index].expanded = !this.purchaseRecords[index].expanded;
      this.consumptionRecords[index].expanded = !this.consumptionRecords[index].expanded;
    },
    handleCurrentChange(val) {
      this.currentPage = val;
    }
  }
};
</script>

<style scoped>
.purchase-container {
  height: 100%;
  margin: 0 auto;
  padding: 40px;
}

/* 移动设备适配 */
@media (max-width: 768px) {
  .purchase-container {
    padding: 20px 16px;
  }
  
  .el-tabs__header {
    margin-bottom: 16px;
  }
  
  .el-tabs__nav-wrap {
    padding: 0 16px;
  }
  
  .el-tabs__item {
    font-size: 14px;
    padding: 0 16px;
  }
  
  .el-table {
    font-size: 12px;
  }
  
  .el-table th,
  .el-table td {
    padding: 8px 4px;
  }
  
  .el-table .cell {
    padding: 0 4px;
  }
  
  .el-pagination {
    margin-top: 16px;
  }
  
  .el-pagination .el-pagination__total {
    font-size: 12px;
  }
  
  .el-pagination .el-pager li {
    min-width: 28px;
    height: 28px;
    line-height: 28px;
    font-size: 12px;
  }
  
  .el-pagination .el-pagination__prev,
  .el-pagination .el-pagination__next {
    min-width: 28px;
    height: 28px;
    line-height: 28px;
    font-size: 12px;
  }
}

/* 平板设备适配 */
@media (min-width: 769px) and (max-width: 1024px) {
  .purchase-container {
    padding: 24px 20px;
  }
  
  .el-tabs__item {
    font-size: 15px;
    padding: 0 20px;
  }
  
  .el-table {
    font-size: 13px;
  }
  
  .el-table th,
  .el-table td {
    padding: 10px 6px;
  }
  
  .el-pagination .el-pager li {
    min-width: 32px;
    height: 32px;
    line-height: 32px;
    font-size: 13px;
  }
  
  .el-pagination .el-pagination__prev,
  .el-pagination .el-pagination__next {
    min-width: 32px;
    height: 32px;
    line-height: 32px;
    font-size: 13px;
  }
}

/* 小屏手机适配 */
@media (max-width: 480px) {
  .purchase-container {
    padding: 16px 12px;
  }
  
  .el-tabs__header {
    margin-bottom: 12px;
  }
  
  .el-tabs__nav-wrap {
    padding: 0 12px;
  }
  
  .el-tabs__item {
    font-size: 13px;
    padding: 0 12px;
  }
  
  .el-table {
    font-size: 11px;
  }
  
  .el-table th,
  .el-table td {
    padding: 6px 2px;
  }
  
  .el-table .cell {
    padding: 0 2px;
  }
  
  .el-pagination {
    margin-top: 12px;
  }
  
  .el-pagination .el-pagination__total {
    font-size: 11px;
  }
  
  .el-pagination .el-pager li {
    min-width: 24px;
    height: 24px;
    line-height: 24px;
    font-size: 11px;
  }
  
  .el-pagination .el-pagination__prev,
  .el-pagination .el-pagination__next {
    min-width: 24px;
    height: 24px;
    line-height: 24px;
    font-size: 11px;
  }
}

/* 横屏手机适配 */
@media (max-width: 900px) and (max-height: 600px) {
  .purchase-container {
    padding: 20px 16px;
  }
  
  .el-tabs__header {
    margin-bottom: 14px;
  }
  
  .el-tabs__item {
    font-size: 14px;
    padding: 0 14px;
  }
  
  .el-table {
    font-size: 12px;
  }
  
  .el-table th,
  .el-table td {
    padding: 6px 4px;
  }
  
  .el-pagination {
    margin-top: 14px;
  }
  
  .el-pagination .el-pager li {
    min-width: 26px;
    height: 26px;
    line-height: 26px;
    font-size: 12px;
  }
  
  .el-pagination .el-pagination__prev,
  .el-pagination .el-pagination__next {
    min-width: 26px;
    height: 26px;
    line-height: 26px;
    font-size: 12px;
  }
}
</style>